export default {"src":"/_next/static/media/ic_translate.e140b0ea.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};